import {Typography} from '@logistics-frontend/blocks'
import type {Optional} from '@logistics-frontend/types'
import {formatDate} from '@logistics-frontend/utils'
import {useFormContext} from '@yandex-delivery/form'
import React from 'react'

import {i18n} from 'src/shared/config'
import type {DeliveryInterval} from 'src/shared/types'
import {toDate} from 'src/shared/utils'

import * as classes from './DeliveryIntervalDescription.classes'
import {Props} from './DeliveryIntervalDescription.types'

export function DeliveryIntervalDescription(props: Props): React.ReactElement | null {
  const {name} = props
  const {watch} = useFormContext()
  const interval: Optional<DeliveryInterval> = watch(name)

  if (interval) {
    const children: string = [
      interval.from && formatterFrom(toDate(interval.from)),
      interval.to && formatterTo(toDate(interval.to)),
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <Typography className={classes.root} variant="body2">
        <Typography thickness="medium" variant="body2">
          {i18n('cargo.create.delivery-interval', 'Заказ заберут и доставят')}
        </Typography>
        {` ${children}`}
      </Typography>
    )
  }

  return null
}

const formatterFrom = formatDate({
  sameDay: i18n('cargo.create.delivery-interval.alert.interval-from.today', '[сегодня с] HH:mm'),
  nextDay: i18n('cargo.create.delivery-interval.alert.interval-from.tomorrow', '[завтра с] HH:mm'),
  nextWeek: 'D MMMM [с] HH:mm',
  sameElse: 'D MMMM [с] HH:mm',
})
const formatterTo = formatDate({
  sameDay: i18n('cargo.create.delivery-interval.alert.interval-to', '[до] HH:mm'),
  nextDay: i18n('cargo.create.delivery-interval.alert.interval-to', '[до] HH:mm'),
  nextWeek: i18n('cargo.create.delivery-interval.alert.interval-to', '[до] HH:mm'),
  sameElse: i18n('cargo.create.delivery-interval.alert.interval-to', '[до] HH:mm'),
})
